import React from 'react';
import {
  OmniAppHeaderSection,
  OmniHeaderSelect,
  type SelectOption,
} from '../ui/appheader';

// Country types
interface CountryAgency {
  value: string;
  label?: string;
}

interface CountrySelectorProps {
  countries: CountryAgency[];
  selectedCountry: CountryAgency | null;
  selectCountry: (value: string) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({
  countries,
  selectedCountry,
  selectCountry,
}) => {
  // Convert CountryAgency to SelectOption format
  const countryOptions: SelectOption[] = countries.map((country) => ({
    value: country.value,
    label: country.label || country.value,
  }));

  return (
    <OmniAppHeaderSection align="center" gap={[1, 2]} position="center">
      {/* Country Selector */}
      <OmniHeaderSelect
        data-tour="country-selector"
        variant="contrast"
        size="sm"
        placeholder="Select country"
        options={countryOptions}
        value={selectedCountry?.value || ''}
        onChange={selectCountry}
        style={{ maxWidth: '150px' }}
      />
    </OmniAppHeaderSection>
  );
};

export default CountrySelector;
